import React, { Component } from "react";
import { AutoComplete, Form, Input, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { apiContract } from "../../../../../api/api-contract";
import { emitter } from "../../../../../common/utils/emitter";
import { CONTRACT_TYPE } from "../../../../../common/utils/static-data";
import { initValues } from "../contract-event";
import { styles } from "../suggestion-styles";
const antIcon = <LoadingOutlined style={{ fontSize: 22 }} spin />;
const { Option } = AutoComplete;
export class ContractCode extends Component {
  constructor(props) {
    super(props);
    const { value } = props;
    if (value) {
      this.state = {
        ...value,
        contractOptions: [],
      };
    } else {
      this.state = {
        prefix_code: "",
        suffix_code: "001",
        contractOptions: [],
      };
    }

    this.timeout = null;
    this.currentValue = null;
    this.totalPage = 1;
    this.page = 1;
  }

  changeContractCode = (feild, text) => {
    const { onChangeForm } = this.props;
    onChangeForm("contract_code", {
      prefix_code: text.toUpperCase(),
      suffix_code: this.state.suffix_code,
    });
    this.setState({ [feild]: text.toUpperCase() });
  };

  onSearch = (data) => {
    var self = this;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    // if (this.currentValue === data.toLocaleUpperCase().trim()) {
    //   return;
    // }
    this.currentValue = data.toLocaleUpperCase().trim();
    this.page = 1;
    if (!data) {
      this.setState({
        contractOptions: [],
      });
      this.onSelect({
        data: {
          code: "",
          suffix_code: "001",
        },
      });
      return;
    }
    async function searchData() {
      let func = apiContract.contractCodeSuggest;

      try {
        const result = await func(data.toLocaleUpperCase().trim(), 1);
        if (result.status === "success") {
          if (self.currentValue !== data.toLocaleUpperCase().trim()) {
            return;
          }
          self.totalPage = result.data.total_pages;

          const minorSearch =
            result.data.content.length > 0 &&
            result.data.content.find(
              (suggestion) =>
                suggestion.code === data.toLocaleUpperCase().trim()
            );
          if (minorSearch) {
            self.onSelect({ data: minorSearch });
          } else {
            const convert = data.toLocaleUpperCase();

            self.onSelect({
              data: {
                code: convert,
                suffix_code: "001",
              },
            });
          }
          self.setState({
            contractOptions: result.data.content.map((suggestion) => {
              return {
                ...suggestion,
                value: suggestion.code,
              };
            }),
          });
        }
      } catch (error) {}
    }

    this.timeout = setTimeout(searchData, 300);
  };

  loadMoreFunc = async () => {
    let func = apiContract.contractCodeSuggest;
    const data = this.currentValue;
    try {
      this.setState({ isLoadMore: true });
      const result = await func(data.toLocaleUpperCase().trim(), this.page);

      if (result.status === "success") {
        this.totalPage = result.data.total_pages;
        const minorSearch = result.data.content.find(
          (suggestion) => suggestion.code === data.toLocaleUpperCase().trim()
        );
        if (minorSearch) {
          this.onSelect({ data: minorSearch });
        } else {
          const convert = data.toLocaleUpperCase();
          this.onSelect({
            data: {
              code: convert,
              suffix_code: "001",
            },
          });
        }
        this.setState(
          {
            contractOptions: this.state.contractOptions.concat(
              result.data.content.map((suggestion) => {
                return {
                  ...suggestion,
                  value: suggestion.code,
                };
              })
            ),
          },
          () => this.setState({ isLoadMore: false })
        );
      } else {
        this.setState({ isLoadMore: false });
      }
    } catch (error) {
      this.setState({ isLoadMore: false });
    }
  };

  getContractData = async (data) => {
    let type = CONTRACT_TYPE.has_driver;
    const { contract_type } = this.props;
    if (contract_type) {
      type = contract_type;
    }
    emitter.emit("FETCH_LOADING", true);
    try {
      const result = await apiContract.cloneContract(data.code, type);
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        if (result.data) {
          this.props.updateForm(
            {
              ...result.data,
              contract_code: {
                prefix_code: data.code,
                suffix_code: data.suffix_code,
              },
            },
            "create_new"
          );
        } else {
          this.props.updateForm(
            {
              ...initValues(true),
              prefix_code: data.code,
              suffix_code: data.suffix_code,
            },
            "create_new"
          );

          const { onChangeForm } = this.props;

          onChangeForm("contract_code", {
            prefix_code: data.code,
            suffix_code: data.suffix_code,
          });
        }
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onSelect = (item) => {
    const { suffix_code } = this.state;
    const { data } = item;
    const { onChangeForm } = this.props;
    if (data.suffix_code !== "001") {
      this.getContractData(data);
    } else {
      if (suffix_code !== "001") {
        this.props.updateForm({ ...initValues(true) });
      }
    }
    this.setState({ prefix_code: data.code, suffix_code: data.suffix_code });
    onChangeForm("contract_code", {
      prefix_code: data.code,
      suffix_code: data.suffix_code,
    });
  };

  suggestionRender = (data) => {
    let loadMore = false;
    loadMore = this.totalPage > this.page;

    const { isLoadMore } = this.state;
    return (
      <>
        {data.map((value) => {
          return (
            <Option
              style={styles.selectOptoption}
              key={value.code}
              data={value}
              value={value.code}
            >
              {value.code}
            </Option>
          );
        })}
        {data.length > 0 && loadMore && !isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div
              onClick={() => {
                this.page++;
                this.loadMoreFunc();
              }}
              style={styles.loadmore}
            >
              Loadmore
            </div>
          </Option>
        )}
        {isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div style={styles.loadmoreLoading}>
              <Spin indicator={antIcon} />
            </div>
          </Option>
        )}
      </>
    );
  };

  render() {
    const { contractOptions, suffix_code, prefix_code } = this.state;

    const { isEdit } = this.props;
    return (
      <Form.Item
        name={"contract_code"}
        rules={[
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value) {
                return Promise.reject("Mã hợp đồng là bắt buộc");
              }
              if (typeof value === "string") {
                if (!value.trim()) {
                  return Promise.reject("Mã hợp đồng là bắt buộc");
                } else {
                  return Promise.resolve();
                }
              } else {
                if (value && value.prefix_code) {
                  return Promise.resolve();
                } else {
                  return Promise.reject("Mã hợp đồng là bắt buộc");
                }
              }
            },
          }),
        ]}
        wrapperCol={24}
      >
        <div className="contract-code">
          <div className="contract-label">Mã hợp đồng</div>
          <div className="input-container">
            <AutoComplete
              disabled={!isEdit}
              getPopupContainer={(node) => {
                if (node) {
                  return node.parentNode;
                }
                return document.body;
              }}
              value={prefix_code}
              ref={(ref) => (this.auto = ref)}
              defaultActiveFirstOption={false}
              onSearch={(data) => this.onSearch(data)}
              placeholder={" Mã hợp đồng"}
              onSelect={(data, option) => this.onSelect(option)}
              onChange={(e) => this.changeContractCode("prefix_code", e)}
              className="contract-name"
            >
              {this.suggestionRender(contractOptions)}
            </AutoComplete>
            <Input value={suffix_code} disabled className="contract-code" />
          </div>
        </div>
      </Form.Item>
    );
  }
}
